import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Typography } from "@mui/material";
import AddConnectors from "components/Manufacturer/VehicleDetails/AddConnectors";
import ConnectorModel from "components/Manufacturer/Models/ConnectorModel";
import DialogEditConnectors from "components/Manufacturer/Models/DialogEditConnectors";
import EnableDecebleConnectors from "components/Manufacturer/Models/EnableDesableConnectors";
import { ManufacturerTableApi } from "stores/ManufacturerStore/ManufacturerApi";

class ConnectorsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openEdit: false,
      connectorsname: "",
      defaultConnectors: "",
      editfile: {
        value: null,
        error: false,
        message: "",
      },
      file: null,
      ConnectorsConfirmDaialog: false,
      ConnectorsStatus: "",
      ConnectorsId: "",
      id: null,
      snackbar: false,
    };
  }

  componentDidMount() {
    this.props.getAddConnectorsAction();
  }

  handleOnChangeEditFile = (e) => {
    let editfile = {
      value: e,
    };
    if (e.size > 102400) {
      editfile["error"] = true;
      editfile["message"] = "File should be less than 1MB";
    }
    this.setState({ editfile });
  };

  handleOnChange = (e) => {
    this.setState({ connectorsname: e.target.value });
  };

  handleClickSubmit = async () => {
    const { id, connectorsname, editfile } = this.state;
    let formData = new FormData();
    formData.append("id", id);
    formData.append("name", connectorsname);
    formData.append("file", editfile.value);

    if (editfile.value) {
      if (editfile.value.size < 102400) {
        if (formData) {
          await ManufacturerTableApi.UpdateAddConnector(formData);
          await this.props.getAddConnectorsAction();
          this.setState({ openEdit: false });
        }
      } else {
      }
    } else {
      if (formData) {
        await ManufacturerTableApi.UpdateAddConnector(formData);

        this.setState({ openEdit: false });

        this.props.getAddConnectorsAction();
      }
    }
  };

  submitConnectorsedit = async (id) => {
    var res = await ManufacturerTableApi.postAddConnectorsModel(id);
    if (res.status === 1) {
      this.handleClickOpen();
    }
    this.props.getAddConnectorsAction();
  };

  handleclickEditOpen = (id, connectorsname) => {
    this.setState({
      openEdit: true,
      id: `${id}`,
      defaultConnectors: connectorsname,
    });
  };

  handleEditUpdateClose = () => {
    this.setState({ openEdit: false });
  };
  handleEditUpdateOpen = () => {
    this.setState({ openEdit: true });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };

  handleConnectorsModelClose = () => {
    this.setState({ ConnectorsConfirmDaialog: false });
  };

  handleStatusConnectors = (id, status) => {
    this.setState({
      ConnectorsConfirmDaialog: true,
      ConnectorsStatus: status,
      ConnectorsId: id,
    });
  };

  handleEnableClickConnectors = async () => {
    const status = this.state.ConnectorsStatus;
    const id = this.state.ConnectorsId;

    if (status === 1) {
      await ManufacturerTableApi.ConnectorsEnableDisable({ id, status: 0 });
      this.setState({ ConnectorsStatus: 0 });

      this.props.getAddConnectorsAction();
    } else {
      await ManufacturerTableApi.ConnectorsEnableDisable({ id, status: 1 });
    }
    this.props.getAddConnectorsAction();

    this.setState({ ConnectorsConfirmDaialog: false });
  };

  render() {
    const connector = this.props?.AddConnectorsTable?.result;
    return (
      <Grid item xs={12}>
        <Stack p={0.5} mt={2}>
          <Breadcrumbs
            sx={{ fontSize: "14px", color: "#0DA861" }}
            separator="›"
            aria-label="breadcrumb"
          >
            <Link
              sx={{ fontSize: "14px" }}
              underline="hover"
              color="#A2A7AE"
              href="/manufacturer"
            >
              Manufacturer
            </Link>
            <Typography sx={{ fontSize: "14px" }} color="#0DA861">
              Add Connectors
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Grid>
          <Paper sx={{ p: 3, mt: 1 }}>
            <AddConnectors
              data={connector}
              onClickModel={this.handleClickOpen}
              onClickEdit={this.handleclickEditOpen}
              submitConnectors={(val) => this.submitConnectorsedit(val)}
              handleStatusConnectors={this.handleStatusConnectors}
            />
          </Paper>
          <ConnectorModel
            handleClose={this.handleClose}
            open={this.state.open}
          />

          <EnableDecebleConnectors
            open={this.state.ConnectorsConfirmDaialog}
            handleEnable={this.handleEnableClickConnectors}
            handleclose={this.handleConnectorsModelClose}
            ConnectorsStatus={this.state.ConnectorsStatus}
          />
        </Grid>
        <DialogEditConnectors
          handleClose={this.handleEditUpdateClose}
          open={this.state.openEdit}
          data={this.state.defaultConnectors}
          value={this.state.connectorsname}
          editfile={this.state.editfile}
          handleOnChange={this.handleOnChange}
          handleClickSubmit={this.handleClickSubmit}
          handleOnChangeEditFile={this.handleOnChangeEditFile}
        />
      </Grid>
    );
  }
}
export default ConnectorsContainer;
